var map = {
	"./amex-logo.svg": 7448,
	"./apple-pay-logo.svg": 5978,
	"./arrow-down-white.svg": 3831,
	"./base-logo.svg": 5773,
	"./circle-dot-regular.svg": 9097,
	"./coinbase-wallet-logo.png": 3384,
	"./google-pay.svg": 2907,
	"./icon-foundation.svg": 5282,
	"./icon-looksrare.svg": 1500,
	"./icon-magic-eden.svg": 3066,
	"./icon-nifty.svg": 2477,
	"./icon-opensea.svg": 3598,
	"./icon-rarible.svg": 4533,
	"./icon-superrare.svg": 2186,
	"./icon-twitter.svg": 8006,
	"./iyk-logo.svg": 5316,
	"./logo_delegate_cash.svg": 5489,
	"./manifold-logograph.svg": 2208,
	"./mastercard-logo.svg": 9474,
	"./matic-logo.svg": 9063,
	"./metamask-logo.png": 3441,
	"./optimism-logo.svg": 685,
	"./twitter-logo.svg": 2707,
	"./visa-logo.svg": 2687,
	"./walletconnect-logo.png": 2994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;